





























































































































































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapMutations } from 'vuex'

@Component({
  components: {},
  methods: mapMutations([])
})
export default class Man extends Vue {
  @Prop() private msg!: string
}
